<template>
  <div v-show="loadedCoupon" class="coupon rounded-lg flex-column h-100 coupon-border p-3">
    <div class="flex-grow">
      <div class="coupon-header d-flex flex-column xs-flex-row ">
        <div v-if="isCreditPackage" class="align-self-center xs-align-self-start coupon-icon coupon-credits"></div>
        <div v-if="!isCreditPackage">
          <svg-coupon-vivaincontri v-if="isVivaincontri" />
          <div v-else class="align-self-center xs-align-self-start coupon-icon coupon-up"></div>
        </div>
        <div class="m-2"></div>
        <div class="mx-auto xs-mx-0 my-auto ">
          <div class="coupon-title text-xs sm-text-sm md-text-base pb-1">
            <h5 class="text-gray-700 font-weight-normal d-inline text-size-inherit">{{ trans.coupon }}</h5>
            <span class="font-weight-bold ">{{ coupon.type_title }}</span>
          </div>
          <div class="coupon-subtitle text-blue-600 text-lg sm-text-xl lg-text-2xl leading-4">
            <h6 class="font-weight-bold m-0 d-inline text-size-inherit">{{ coupon.title }}</h6>
            <span v-if="isCttProduct"
                  class="font-weight-bold text-lg sm-text-xl lg-text-2xl text-pink-600 text-sm sm-text-base lg-text-lg">{{ coupon.product.value }}</span>
          </div>
          <div v-if="coupon.description" class="coupon-description pt-1 pt-sm-0 text-xs">
            <span class="font-weight-light">{{ coupon.description }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-2"></div>
    <hr class="m-0" v-if="!this.isCttProduct">
    <div v-if="this.isCttProduct" class="form-group mt-4 mb-2">
      <div class="mt-0 mb-2"><span class="text-muted day">{{ this.time_range }}</span> <!----></div>
      <select v-if="isPromotePage" class="browser-default custom-select"
        ref="select"
        @click.stop.prevent="onSelectChange"
        v-model="productCode"
        tabindex="-1"
        data-toggle="popover"
        data-trigger="manual"
        :data-content="templateTrans?templateTrans[0]:''"
        data-placement="bottom" :disabled="!$parent.couponSelected">
        <option value=""> {{templateTrans?templateTrans[0]:""}}</option>
        <option
          v-for="interval in timeIntervals"
          :value="interval.ctt_product_id">{{interval.start}} - {{interval.end}}
        </option>
      </select>
    </div>
    <div class="mt-3 coupon-footer d-flex justify-content-between align-items-center">
      <use-coupon v-if="isCreditPackage" :url-use-coupon="urlUseCoupon" :id="coupon.id"></use-coupon>
      <div v-if="isCttProduct||isAddons"
           class="coupon-subtitle text-blue-600 text-lg sm-text-xl lg-text-2xl leading-4">
        <h6 class="text-blue-600 font-weight-light text-base m-0 d-block leading-3">
          {{ trans.can_use_it_when_promoting }}
        </h6>
      </div>
      <div class="mx-2"></div>
      <div class="  d-flex flex-column align-self-center">
        <small class="text-muted">{{ trans.expires_on }}:</small>
        <small class="">{{ coupon.valid_to }}</small>
      </div>
    </div>
  </div>
</template>
<script>
// import Translations from "./insert-me-to-translate.vue";

import UseCoupon from "./use-coupon"
const PROMOTION_FREE = 1
const PROMOTION_EXTRA_CREDITS = 2
const EMPTY_COUPON = {
  id: '',
  code: null,
  valid_for: null,
  promotion_type: null,
  discount_rate: null,
  valid_from: null,
  valid_to: null,
  type_title: '',
  title: '',
  product: null,
  description: ''
}

export default {
  name: "Coupon",
  props: {
    presetCoupon: {
      type: Object,
      required: false
    },
    isPreview: {
      type: Boolean,
      required: false,
      default: false
    },
    urlUseCoupon: {
      required: false,
      type: String
    },
    templateTrans: {
      type: Array,
      required: false,
    },
    isPromotePage: {
      required: false,
      default: false,
      type: Boolean
    },
    isVivaincontri: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      coupon: EMPTY_COUPON,
      productCode: ""
      }
  },
  components: {
    UseCoupon,
    SvgCouponVivaincontri: () => import(/* webpackChunkName: "svg-add-coupon-vivaincontri" */ "../../svg/coupon-vivaincontri.vue"),
  },
  computed: {

    loadedCoupon() {
      return this.coupon.id !== '' && (!this.isPromotePage || this.product!=null)
    },
    isCreditPackage() {
      return this.coupon.valid_for === 'database.models.product.CreditPackageProduct'
    },
    isCttProduct() {
      return this.coupon.valid_for === 'database.models.product.CttProduct'
    },
    isAddons() {
      return this.coupon.valid_for === 'addons'
    },
    isPromotionFree() {
      return this.coupon.promotion_type === PROMOTION_FREE
    },
    isPromotionExtraCredits() {
      return this.coupon.promotion_type === PROMOTION_EXTRA_CREDITS
    },
    product() {
      let climbTimes, days;
      [climbTimes, days] = this.coupon.product.value.split("x")
      if (this.$parent.initProducts) {
        return this.$parent.initProducts.find(value => ((parseInt(value.climb_times) === parseInt(climbTimes)) && (parseInt(value.days) === parseInt(days))))
      }
    },
    timeIntervals() {
      if (this.product) {
        return this.product.time_intervals
      }
      return []
    },
    time_range() {
      if (this.product) {
        return this.product.time_range === 0 ? "Day" : "Night"
      }
    }
  },
  methods: {
    setFather(event){
      // $parent.timeIntervalCodeSelections[product.code] = event.target.value
    },
    consume(){
      console.log("should consume")
    },
    onSelectChange(){
        let lastPopoverItem = $(this.$refs.select)
        lastPopoverItem.popover("hide");
    }
  },
  created() {
    this.trans = {
      coupon: gettext("Coupon"),
      can_use_it_when_promoting: gettext('You can use it when promoting'),
      error_title: gettext("An unexpected error has occurred"),
      invalid_coupon: gettext('Invalid coupon'),
      expires_on: gettext('expires on'),
      close: gettext('Close')
    }
  },
  mounted() {
    if (this.presetCoupon) {
      this.coupon = this.presetCoupon
    }
    if (this.isPreview) {
      this.$store.dispatch("coupons/setPreviewCoupon", this).then()
    }
  }
}
</script>

